document.addEventListener("DOMContentLoaded", () => {

    const grid = document.querySelector(".product-list, .collection__products, .collection__product-list");

    if (!grid) return;

    let loading = false;

    async function loadNextPage() {

        if (loading) return;

        const nextLink = document.querySelector('.pagination a[rel="next"], .pagination__next');

        if (!nextLink) return;

        loading = true;

        const loader = document.createElement("div");
        loader.className = "infinite-loader";
        loader.innerHTML = "Caricamento prodotti...";
        grid.after(loader);

        try {

            const response = await fetch(nextLink.href);

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(html, "text/html");

            const newGrid = doc.querySelector(".product-list, .collection__products, .collection__product-list");

            if (newGrid) {

                grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);

            }

            const newNext = doc.querySelector('.pagination a[rel="next"], .pagination__next');

            if (newNext) {

                nextLink.href = newNext.href;

            } else {

                nextLink.remove();

            }

        }

        catch(e){

            console.error(e);

        }

        loader.remove();

        loading = false;

    }

    window.addEventListener("scroll", () => {

        if(window.innerHeight + window.scrollY >= document.body.offsetHeight - 800){

            loadNextPage();

        }

    });

});